import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/app_download/google_play.png'
import _imports_1 from '@/assets/app_download/app_store.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "前往官網預訂", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "第 1 步"),
  /*#__PURE__*/_createElementVNode("p", null, "請先登入官網")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " 登入 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "第 2 步"),
  /*#__PURE__*/_createElementVNode("p", null, "登入後點此預訂場地")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, " 確認 ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " 預訂 ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "查詢結果", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "btnWrap"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("small", null, "場地資料顯示偶有延遲，詳細資訊請見官網")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Arrow = _resolveComponent("Arrow")!
  const _component_Warning = _resolveComponent("Warning")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.bookingBlock)
  }, [
    (_ctx.errorObj.status === 'idle' && _ctx.bookingInfo.remark.bookingUrl)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.subheading)
          }, [
            _hoisted_1,
            _createVNode(_component_Button, {
              class: _normalizeClass(_ctx.isCopied && _ctx.$style.toggled),
              btnName: _ctx.isCopied ? 'Check' : 'Link',
              btyType: "basic",
              title: "複製連結",
              message: _ctx.isCopied ? '已複製' : '複製連結',
              onClick: _cache[0] || (_cache[0] = () => !_ctx.isCopied && _ctx.copyLink())
            }, null, 8, ["class", "btnName", "message"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.bookingInfo)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.step),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLink('login')))
            }, [
              _hoisted_2,
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.btn)
              }, [
                _createElementVNode("div", null, [
                  _hoisted_3,
                  _createVNode(_component_Arrow, {
                    style: _normalizeStyle({ transform: 'rotate(-90deg)' })
                  }, null, 8, ["style"])
                ])
              ], 2)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.step),
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
            _ctx.isLinkOpen ? _ctx.openLink('booking') : (_ctx.isLinkOpen = true)
          ), ["prevent"])),
              onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isLinkOpen = false))
            }, [
              _hoisted_4,
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.$style.btn, { [_ctx.$style.unlocked]: _ctx.isLinkOpen }])
              }, [
                _createElementVNode("div", {
                  style: _normalizeStyle({ marginLeft: _ctx.isLinkOpen ? '0%' : '-100%' })
                }, [
                  _hoisted_5,
                  _createVNode(_component_Arrow, {
                    style: _normalizeStyle({ transform: 'rotate(-90deg)' })
                  }, null, 8, ["style"])
                ], 4),
                _createElementVNode("div", {
                  style: _normalizeStyle({ marginRight: !_ctx.isLinkOpen ? '0%' : '-100%' })
                }, [
                  _hoisted_6,
                  _createVNode(_component_Arrow, {
                    style: _normalizeStyle({ transform: 'rotate(-90deg)' })
                  }, null, 8, ["style"])
                ], 4)
              ], 2)
            ], 34)
          ], 2)
        ], 64))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.$style.bookingInfo)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.subheading)
          }, _hoisted_8, 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.noData)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.image)
            }, [
              _createVNode(_component_Warning)
            ], 2),
            _createElementVNode("h3", null, _toDisplayString(_ctx.errorObj.title), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.errorObj.message), 1),
            (_ctx.errorObj.hasApp)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass(_ctx.$style.appDownload)
                }, [
                  _createElementVNode("a", {
                    href: _ctx.venueInfo?.androidLink,
                    target: "_blank",
                    rel: "noreferrer noopenner"
                  }, _hoisted_11, 8, _hoisted_9),
                  _createElementVNode("a", {
                    href: _ctx.venueInfo?.iosLink,
                    target: "_blank",
                    rel: "noreferrer noopenner"
                  }, _hoisted_14, 8, _hoisted_12)
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hasCourt ? (_ctx.closeBooking(), _ctx.resetError()) : _ctx.closeModal()))
                  }, _toDisplayString(_ctx.hasCourt ? '其他場地' : '其他時段'), 1),
                  _createElementVNode("div", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeModal(), _ctx.resetFilter()))
                  }, "重新查詢")
                ]))
          ], 2)
        ], 2)),
    _hoisted_16
  ], 2))
}